import { axios } from '@/utils/request'

export const categoryList = (type = '') => {
  return axios.get(`/api/web/mall/category/list?type=${type}`)
}
